module.exports = __webpack_public_path__ + "media/images/lps-car-7afa858c.png";